import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT || '';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export interface StaffAvailsFilters {
  date?: string;
  staff_email?: string;
  start_date?: string;
  end_date?: string;
}

export interface StaffAvail {
  staff_email: string;
  staff_name: string;
  role: string;
  date: string;
  created_at: string;
}

export interface StaffAvailsResponse {
  avails: StaffAvail[];
  count: number;
}

export interface IngestStaffAvailsRequest {
  avails_sheet_id: string;
  clear_existing?: boolean;
}

export interface IngestStaffAvailsResponse {
  success: boolean;
  message: string;
  statistics: {
    dates_count: number;
    total_avails: number;
    ingested: number;
    errors: number;
  };
  dates: string[];
}

export const getStaffAvails = async (filters?: StaffAvailsFilters): Promise<StaffAvailsResponse> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString() || '';

    // Build query string
    const params = new URLSearchParams();
    if (filters) {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value));
        }
      });
    }

    const queryString = params.toString();
    const url = `/staff-avails${queryString ? `?${queryString}` : ''}`;

    const response = await api.get(url, {
      headers: {
        Authorization: token,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error('Error fetching staff avails:', error);
    throw new Error(error.response?.data?.error || 'Failed to fetch staff avails');
  }
};

export const ingestStaffAvails = async (data: IngestStaffAvailsRequest): Promise<IngestStaffAvailsResponse> => {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.idToken?.toString() || '';

    const response = await api.post('/staff-avails/ingest', data, {
      headers: {
        Authorization: token,
      },
    });

    return response.data;
  } catch (error: any) {
    console.error('Error ingesting staff avails:', error);
    throw new Error(error.response?.data?.error || 'Failed to ingest staff avails');
  }
};
